import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './_metronic/assets/sass/style.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/font-awesome/5.15.2/scss/fontawesome.scss';
import './assets/font-awesome/5.15.2/scss/light.scss';
import './assets/font-awesome/5.15.2/scss/brands.scss';
import './assets/font-awesome/5.15.2/scss/duotone.scss';
import './assets/font-awesome/5.15.2/scss/regular.scss';
import './assets/font-awesome/5.15.2/scss/solid.scss';
import ReactDOM from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import 'react-tooltip/dist/react-tooltip.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
